import { z } from "zod";

const ageRangeRowSchema = z.object({
  max: z.number({ error: "Required" }).min(5, "Minimum is 5").max(200, "Maximum is 200"),
  min: z.number({ error: "Required" }).min(5, "Minimum is 5").max(200, "Maximum is 200"),
});

export const ageRangeSchema = z.object({
  ranges: z.array(ageRangeRowSchema).min(1),
});

export type AgeRangeFormValues = z.infer<typeof ageRangeSchema>;
